import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/styles/light-theme.css";
import App from "@/App";
import { ThemeProvider } from "next-themes";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* Follows the device until the user picks a theme; the choice stays in this browser. */}
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem storageKey="autotu-theme" disableTransitionOnChange>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
);
